import { render, staticRenderFns } from "./ExampleModal.vue?vue&type=template&id=296f8ac2&"
import script from "./ExampleModal.vue?vue&type=script&lang=ts&"
export * from "./ExampleModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports